import { Injectable } from '@angular/core';
import {
  Waterlog,
  Waterlogs,
} from 'src/app/core/model/api-response/water-log-response-model';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { LogoutService } from '../user-repository/logout.service';

@Injectable({
  providedIn: 'root',
})
export class WaterLogDataService {
  constructor(
    private dbService: NgxIndexedDBService,
    private logoutService: LogoutService
  ) {}

  public async getWaterLogs(): Promise<Waterlogs> {
    let waterlogs: Waterlog[];
    const response = await this.dbService.getAll('waterlogs').then(
      (wl) => {
        waterlogs = [];
        wl.forEach((waterlog) => {
          const w = new Waterlog(
            waterlog['amount'],
            waterlog['date'],
            waterlog['_id']
          );
          waterlogs.push(w);
        });
        const waterlogsUpdatedAt = localStorage.getItem('waterlogsUpdatedAt');
        const waterlogsModel = new Waterlogs(waterlogs, waterlogsUpdatedAt);
        return waterlogsModel;
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return new Waterlogs(null, null);
      }
    );
    return Promise.resolve(response);
  }

  public async getWaterLog(date: number): Promise<Waterlog> {
    const response = await this.dbService
      .getByIndex('waterlogs', 'date', date)
      .then(
        (waterlog) => {
          if (waterlog) {
            const w = new Waterlog(
              waterlog['amount'],
              waterlog['date'],
              waterlog['_id']
            );
            return w;
          } else {
            return new Waterlog(0, 0, '');
          }
        },
        (error) => {
          console.log(error);
          this.logoutService.logout();
          return new Waterlog(null, null, null);
        }
      );
    return Promise.resolve(response);
  }

  public async getCustomWaterLogs(
    startDate: number,
    endDate: number
  ): Promise<Waterlogs> {
    let waterlogs: Waterlog[];
    const response = await this.dbService
      .getAllByIndex('waterlogs', 'date', IDBKeyRange.bound(endDate, startDate))
      .then(
        (wl) => {
          waterlogs = [];
          wl.forEach((waterlog) => {
            const w = new Waterlog(
              waterlog['amount'],
              waterlog['date'],
              waterlog['_id']
            );
            waterlogs.push(w);
          });
          const waterlogsUpdatedAt = localStorage.getItem('waterlogsUpdatedAt');
          const waterlogsModel = new Waterlogs(waterlogs, waterlogsUpdatedAt);
          return waterlogsModel;
        },
        (error) => {
          console.log(error);
          this.logoutService.logout();
          return new Waterlogs(null, null);
        }
      );
    return Promise.resolve(response);
  }

  public async saveWaterLogs(res: Waterlog[]): Promise<boolean> {
    localStorage.setItem('waterlogsUpdatedAt', new Date().toISOString());
    await this.removeWaterLogs();

    if (res.length === 0) {
      return Promise.resolve(true);
    }
    res.forEach(async (waterlog) => {
      console.log(waterlog);

      this.dbService
        .add('waterlogs', {
          amount: waterlog.amount,
          date: new Date(waterlog.date).setHours(0, 0, 1, 0),
          _id: waterlog._id,
        })
        .then(
          () => {},
          (error) => {
            console.log(error);
            this.logoutService.logout();
          }
        );
    });
  }

  public async addWaterLog(waterlog: Waterlog): Promise<boolean> {
    localStorage.setItem('waterlogsUpdatedAt', new Date().toISOString());
    if (!waterlog) {
      return Promise.resolve(true);
    }
    this.dbService
      .add('waterlogs', {
        amount: waterlog.amount,
        date: new Date(waterlog.date).setHours(0, 0, 1, 0),
        _id: waterlog._id,
      })
      .then(
        () => {},
        (error) => {
          console.log(error);
          this.logoutService.logout();
        }
      );
  }

  public async updateWaterLog(amount: number, id: string): Promise<boolean> {
    localStorage.setItem('waterlogsUpdatedAt', new Date().toISOString());
    if (!id) {
      return Promise.resolve(true);
    }
    await this.dbService.getByIndex('waterlogs', '_id', id).then(
      async (w) => {
        await this.dbService
          .update('waterlogs', {
            id: w.id,
            amount: amount,
            date: w.date,
            _id: w._id,
          })
          .then(
            () => {},
            (error) => {
              console.log(error);
              this.logoutService.logout();
            }
          );
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return new Waterlog(null, null, null);
      }
    );
  }

  public async removeWaterLogs(): Promise<boolean> {
    const response = await this.dbService.clear('waterlogs').then(
      () => {
        return true;
        // Do something after clear
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return false;
      }
    );
    return Promise.resolve(response);
  }

  convertDateToMidNight(date: number): number {
    return new Date(date).setHours(0, 0, 1, 0);
  }
}
